<template>
	<v-list-item class="mb-0 justify-space-between pl-3">
		<a href="/" target="_blank">
			<img src="/logo.png" style="max-width: 100px;max-height: 50px;" />
		</a>
		<v-list-item-content class="pl-2">
			<v-list-item-title class="text-h3">
				<strong class="mr-1 font-weight-black">{{ titlePart1 }}</strong>
				<span class="primary--text">{{ titlePart2 }}</span>
				<div class="text-h6" style="white-space: nowrap;">پنل نمایندگان - {{ customerName }}</div>
				<user-business-name :hideCustomer="true" />
			</v-list-item-title>
		</v-list-item-content>
	</v-list-item>
</template>

<script>
// Utilities
import { get } from 'vuex-pathify'
import UserBusinessName from '@/components/BusinessName'
import NationalCode from '@/components/NationalCode'

export default {
	name: 'DefaultDrawerHeader',
	components: {
		UserBusinessName,
		NationalCode,
	},
	computed: {
		version: get('app/version'),
		...get('auth', [
			'getCurrentUser',
		]),
		...get('siteConfig', [
			'isCloud', 'fullTitle', 'titlePart1', 'titlePart2'
		]),
		customerName() {
			var user = this.getCurrentUser
			if (user && user.userData && user.userData.customer) { return `${user.userData.customer.name}` }
			return ''
		}
	},
	methods: {

	}
}
</script>
